module.exports = "<p>\n  table-speed works!\n</p>\n"